@if (
  {
    projects: projects$ | async,
    challenges: challenges$ | async,
    selectedProject: selectedProject$ | async,
    loading: loading$ | async,
    projectSkeds: projectSkeds$ | async,
    projectActionOptions
  };
  as state
) {
  <header>
    <oph-back-button (buttonClick)="onBackClick()"></oph-back-button>
    <div class="header-top-container">
      <project-selector [selectedProject]="state.selectedProject" [loading]="state.loading?.projectAction">
        <!-- PROJECT MENU ITEMS -->
        <ng-container class="project-selector">
          <div class="create-project-button-container">
            <oph-button
              color="orange"
              [style]="{width: '100%', minWidth: '300px'}"
              (buttonClick)="onOpenProjectDialog()"
            >
              <mat-icon svgIcon="plus"></mat-icon>
              New</oph-button
            >
          </div>
          @for (challenge of state.challenges; track challenge) {
            <project-selector-menu-project-button
              [project]="challenge"
              [isSelected]="challenge?.label === state.selectedProject?.label"
              (buttonClick)="selectProject(challenge)"
            ></project-selector-menu-project-button>
          }
          @for (project of state.projects; track project) {
            <project-selector-menu-project-button
              [project]="project"
              [isSelected]="project?.label === state.selectedProject?.label"
              (buttonClick)="selectProject(project)"
            ></project-selector-menu-project-button>
          }
        </ng-container>
        <!-- PROJECT ACTION MENU ITEMS -->
        @for (option of state.projectActionOptions; track option) {
          <project-selector-menu-action-button
            class="project-menu"
            [option]="option"
            (buttonClick)="onProjectAction(option.action)"
          ></project-selector-menu-action-button>
        }
      </project-selector>
      @if (project(); as currentProject) {
        <oph-button
          class="edit-button"
          color="orange"
          [style]="{borderRadius: '10px', padding: '0 30px', width: '180px'}"
          (buttonClick)="onEditClick()"
        >
          <mat-icon class="edit-button-icon icon" svgIcon="pencil-outline"></mat-icon>
          {{ editButtonLabel() }}
        </oph-button>
      }

      <project-row-menu [project]="project()" [inHeader]="true" [isChallenge]="project()?.isChallenge ?? false" />
    </div>

    @if (!project()?.isChallenge) {
      <div class="header-bottom-row">
        <projects-sked-selector [skeds]="state.projectSkeds" (addSked)="onAddSked()"></projects-sked-selector>

        <div class="header-bottom-right-container">
          <oph-avatar-multi
            [userIds]="state.selectedProject?.users"
            [teamsIds]="state.selectedProject?.teams"
            [tooltipPosition]="'below'"
            [toolTipDisabled]="false"
            [avatarSize]="28"
            (click)="onAddUser()"
          ></oph-avatar-multi>
        </div>
      </div>
    }
  </header>
}
